/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
import { Accordion, AccordionDetails, AccordionSummary, Box, useTheme, withStyles, withTheme } from '@material-ui/core';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import CrudTable from '../clients/details/crudTable.component';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { useState } from 'react';
import Spinner from 'modules/common/spinner.component';
import classNames from 'classnames';
import { deleteExpense, getExpenseSummaries, createExpense, updateExpense } from 'modules/expenses/store/expenses.actions';
import {
  DELETE_EXPENSE_SUMMARY_FAILURE,
  GET_EXPENSE_SUMMARIES_FAILURE,
  POST_EXPENSE_SUMMARY_FAILURE,
  UPDATE_EXPENSE_SUMMARY_FAILURE
} from 'modules/expenses/store/types';

const styles = theme => ({
  row: { backgroundColor: theme.palette.common.white },
  inputGroup: { display: 'inline-flex', justifyContent: 'space-between' },
  root: { maxWidth: 170, marginRight: 10 },
  extRoot: { width: 115, marginRight: 10 },
  primaryContactRow: { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' },
  primaryText: { paddingTop: 12, paddingRight: 5 },
  newRow: { display: 'flex', flexDirection: 'column', maxWidth: 1050 }
});

const ZERO_GUID = '00000000-0000-0000-0000-000000000000';
const TRANSFEREE_PAYEE_TYPE = 'c3b2c3c1-0324-4c7b-8b97-ef3f3a4a3f6e';
const FIXED_AUTHORIZATION_ID = 5;

const buildExpenseRequestFromUi = (values, expenseId, orgRow = null) => {
  return {
    payee: {
      payeeId: orgRow?.payeeId,
      payeeTypeId: TRANSFEREE_PAYEE_TYPE,
      vendorId: null,
      authorizationId: values?.fileId || FIXED_AUTHORIZATION_ID,
      transfereePayeeId: orgRow?.transfereePayeeId,
      vendorPayeeId: null
    },
    expenseInformation: {
      expenseId: expenseId ?? 0,
      payeeId: 0,
      expenseStatusId: ZERO_GUID,
      dateSubmitted: values?.dateSubmitted ?? null,
      description: values?.description ?? '',
      total: values?.total ? Number.parseFloat(values.total) : 0,
      expenseAnalystId: null,
      reimbursementTypeId: ZERO_GUID,
      payInCurrencyId: ZERO_GUID,
      equivalentCurrencyId: ZERO_GUID,
      batchTypeId: ZERO_GUID,
      isNotPayable: false,
      isRushPayment: false,
      isExpenseApproved: false
    },
    addressInformation: null,
    bankingInformation: null,
    expenseLineItems: []
  };
};

const projectSummariesForTable = expenseSummaries =>
  (expenseSummaries || []).map(s => ({
    expenseId: s.expenseId,
    dateSubmitted: s.submittedDate ?? null,
    description: s.description ?? '',
    total: s.totalAmount ?? 0,
    fileId: s?.authorizationFileId
  }));

const ExpenseTable = props => {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const authoirzationOptions = (props.authorizations || []).map(a => ({
    id: a.fileId,
    title: `${a.firstName} ${a.lastName}`
  }));

  const adjustedColumns = [
    { accessorKey: 'dateSubmitted', header: 'Date Submitted', type: 'date', required: true, size: 60 },
    { accessorKey: 'description', header: 'Description', type: 'text', required: true, size: 120 },
    { accessorKey: 'total', header: 'Total', type: 'money', required: true, size: 40 },
    {
      accessorKey: 'fileId',
      header: 'Authorization',
      type: 'dropdown-v2',
      options: authoirzationOptions,
      required: true,
      size: 40
    }
  ];

  const createRow = async values => {
    setIsLoading(true);
    const body = buildExpenseRequestFromUi(values, 0);
    const resp = await props.postExpenseSummary(body);
    if (resp.type === POST_EXPENSE_SUMMARY_FAILURE) return false;

    const getResp = await props.getExpenseSummaries();
    setIsLoading(false);
    return getResp.type !== GET_EXPENSE_SUMMARIES_FAILURE;
  };

  const updateRow = async (orgRow, newRow) => {
    setIsLoading(true);
    const expenseId = orgRow?.original?.expenseId;
    if (!expenseId) return false;

    const body = buildExpenseRequestFromUi(newRow, expenseId, orgRow);
    const resp = await props.updateExpenseSummary(body, expenseId);
    if (resp.type === UPDATE_EXPENSE_SUMMARY_FAILURE) return false;

    const getResp = await props.getExpenseSummaries();
    setIsLoading(false);
    return getResp.type !== GET_EXPENSE_SUMMARIES_FAILURE;
  };

  const deleteRow = async rowToDelete => {
    setIsLoading(true);
    const id = rowToDelete.original.expenseId;
    const resp = await props.deleteExpenseSummary(id);
    if (resp.type === DELETE_EXPENSE_SUMMARY_FAILURE) return false;

    const getResp = await props.getExpenseSummaries();
    setIsLoading(false);
    return getResp.type !== GET_EXPENSE_SUMMARIES_FAILURE;
  };

  const tableRows = projectSummariesForTable(props.expenseSummaries);

  return (
    <Accordion expanded={isOpen} onChange={() => setIsOpen(!isOpen)} classes={{ root: classNames(props.classes.accordionStyleContacts) }}>
      <AccordionSummary
        expandIcon={
          <Box color={theme.palette.secondary.main}>
            <ExpandMoreIcon color="inherit" />
          </Box>
        }
      >
        <div className={props.classes.newRow}>
          <h2>Expense Summaries</h2>
        </div>
      </AccordionSummary>

      <AccordionDetails>
        {!isLoading && props.expenseSummaries && (
          <div>
            <CrudTable
              editingMode="modal"
              columns={adjustedColumns}
              rows={tableRows}
              updateRow={updateRow}
              createRow={createRow}
              deleteRow={deleteRow}
            />
          </div>
        )}
        {isLoading && <Spinner />}
      </AccordionDetails>
    </Accordion>
  );
};

export default compose(
  withStyles(styles),
  withTheme,
  connect(null, {
    updateExpenseSummary: updateExpense,
    deleteExpenseSummary: deleteExpense,
    postExpenseSummary: createExpense,
    getExpenseSummaries
  })
)(ExpenseTable);
